import React from 'react'
import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'
import useTranslate from '../../i18n/useTranslate'

export type FormParam = {
    email: string
}

const usePreferenceForgotPassword = () => {
    const callApi = useCallApi()
    const t = useTranslate()

    const postPreferencesForgotPassword = async (email: string) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServinceURL.postPreferencesForgotPassword,
            authorizationType: 'authorization',
            params: {
                subject: t.get('UM.FORGOTPASSWORD.SUBJECT_SEND_EMAI'),
                email: email,
            },
        })
        return data
    }

    return {
        postPreferencesForgotPassword,
    }
}

export default usePreferenceForgotPassword
